export default __webpack_public_path__ + "static/media/I0004.f2193cf9.png";